import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  defaultValue?: string;
  variant?: 'light' | 'dark';
  placeholder?: string;
  onSubmitted?: () => void;
}

export default function SearchBox({
  defaultValue = '',
  variant = 'light',
  placeholder = '搜索剧名、演员或资讯',
  onSubmitted,
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    onSubmitted?.();
  };

  const wrapper =
    variant === 'light'
      ? 'bg-background-50 border border-background-300 focus-within:border-primary-400'
      : 'bg-white/15 border border-white/25 focus-within:border-white/60 backdrop-blur-sm';
  const textColor = variant === 'light' ? 'text-foreground-900 placeholder:text-foreground-400' : 'text-white placeholder:text-white/70';
  const iconColor = variant === 'light' ? 'text-foreground-400' : 'text-white/80';

  return (
    <form onSubmit={handleSubmit} className={`flex items-center gap-2 rounded-full pl-3 pr-1 py-1 transition-colors ${wrapper}`}>
      <i className={`ri-search-line text-base ${iconColor}`}></i>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={`flex-1 min-w-0 bg-transparent text-sm outline-none py-1.5 ${textColor}`}
      />
      {value && (
        <button
          type="button"
          onClick={() => setValue('')}
          aria-label="清除搜索"
          className={`cursor-pointer w-6 h-6 flex items-center justify-center rounded-full ${iconColor}`}
        >
          <i className="ri-close-circle-line text-base"></i>
        </button>
      )}
      <button
        type="submit"
        className="cursor-pointer whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-4 py-1.5 rounded-full transition-colors"
      >
        搜索
      </button>
    </form>
  );
}